import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import Box from '@mui/material/Box';

interface SortableItemProps {
  children: React.ReactNode;
  id: string;
  minHeight?: number;

  disableDrag?: boolean;
}

const SortableItem = (props: SortableItemProps) => {
  const { children, id, disableDrag = false, minHeight = 100 } = props;
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 999 : 10,
  };

  function renderContent() {
    if (!isDragging) {
      return children;
    }
    return (
      <Box border="1px dashed grey" minHeight={minHeight}>
        <Box sx={{ opacity: 0.2 }}>{children}</Box>
      </Box>
    );
  }

  if (disableDrag) {
    return <>{children}</>;
  }

  return (
    <Box
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      sx={{
        '&:hover': {
          cursor: 'grab',
        },
      }}
    >
      {renderContent()}
    </Box>
  );
};

export default SortableItem;
